import { HelpService } from '@services/help/help.service';
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { HelpLinks } from '@core/models';

@Directive({
  selector: '[appIfLink]'
})
export class IfLinkDirective {
  private active = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private helpService: HelpService
  ) {}

  @Input() set appIfLink(code: HelpLinks) {
    const active = this.helpService.isLinkActive(code);

    if (active && !this.active) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.active = true;
    } else if (!active && this.active) {
      this.viewContainer.clear();
      this.active = false;
    }
  }
}
